module.exports = __webpack_public_path__ + "static/media/cross_black.0438ca8b.svg";